import { AxiosResponse, InternalAxiosRequestConfig } from './types'
import { ElMessage } from 'element-plus'
import qs from 'qs'
import { SUCCESS_CODE, TRANSFORM_REQUEST_DATA } from '@/constants'
// import { useRouter } from 'vue-router'
import  router  from '@/router'
import { useUserStoreWithOut } from '@/store/modules/user'
import { objToFormData } from '@/utils'

const defaultRequestInterceptors = (config: InternalAxiosRequestConfig) => {
  if (
    config.method === 'post' &&
    config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
  ) {
    config.data = qs.stringify(config.data)
  } else if (
    TRANSFORM_REQUEST_DATA &&
    config.method === 'post' &&
    config.headers['Content-Type'] === 'multipart/form-data' &&
    !(config.data instanceof FormData)
  ) {
    config.data = objToFormData(config.data)
  }
  if ((config.method === 'get') && config.params) {
    let url = config.url as string
    url += '?'
    const keys = Object.keys(config.params)
    for (const key of keys) {
      if (config.params[key] !== void 0 && config.params[key] !== null) {
        url += `${key}=${encodeURIComponent(config.params[key])}&`
      }
    }
    url = url.substring(0, url.length - 1)
    config.params = {}
    config.url = url
  }
  return config
}

const defaultResponseInterceptors = (response: AxiosResponse) => {
  if (response?.config?.responseType === 'blob' && (response.data.type == 'application/vnd.ms-excel' || response.data.type == 'text/xml')) {
    // let res = response.data
    // if (response.config.responseType == 'blob') {
    //   const reader = new FileReader();
    //   // reader.readAsText(res, "UTF-8");
    //   // reader.onload = function () {
    //   //   res = JSON.parse(reader.result);
    //   //   debugger
    //   //   // doJsonData(res);
    //   // }
    //   return res;
    // }
    return response.data
  } else if (response.data.success) {
    const result = response.data
    if(result.code == "302" && !!result.redirectUrl) {
      try {
        if(~response.request.responseURL.indexOf("assist-enroll")) {
          // 包含
          return result
        }
        const { redirectUrl: path } = result
        router.push({path})
      } catch(err) {
        console.log('【route push error】;', err)
      }
    }
    return result.data
  } else {
    ElMessage.error(response?.data?.message)
    if (response?.data?.code == "302") {
      const userStore = useUserStoreWithOut()
      userStore.logout()
    }
    if (response?.data?.code == "401") {
      const userStore = useUserStoreWithOut()
      userStore.logout()
    }
    // return false
    return Promise.reject(new Error(response?.data?.message || 'Error'))
  }
}

// const doJsonData = res => {
//   if (!res.success) {
//     const { code, message } = res
//     !!message && ElMessage.warning(message)
//     if(code == '401') {
//       const userStore = useUserStoreWithOut()
//       userStore.logout()
//     } 
//     return Promise.reject(new Error(res.message || 'Error'))
//   } else {
//     return res
//   }
// }

// const defaultResponseInterceptorsV2 = (response: AxiosResponse) => {
//   if (~response.headers["content-type"].indexOf("application/json")) {
//     let res = response.data
//     if (response.config.responseType == 'blob' && res.type == 'application/json') {
//       const reader = new FileReader()
//       reader.readAsText(res, "UTF-8")
//       reader.onload = function () {
//         res = JSON.parse(reader.result)
//         doJsonData(res);
//       }
//       return
//     }
//     return res
//   }
//   return response
// }

export { defaultResponseInterceptors, defaultRequestInterceptors }
